import { ActivatedRoute, Router } from '@angular/router';
import { Component } from '@angular/core';

@Component({
    selector: 'app-redirect',
    template: 'Aguarde enquanto efetuamos o login automatico no sistema..',
    styles: [''],
})
export class RedirectComponent {
    queryParams = { queryParams: {'unconformities_only':'false'}}

    constructor(private route: ActivatedRoute, private router : Router) {
        this.route.queryParams.subscribe((params) => this.delay(1000).then(() => this.accessPage(params.id)));
    }

    delay = (ms: number) => new Promise(res => setTimeout(res, ms));

    accessPage = (value) => this.router.navigate(['/checklist-answered', value], this.queryParams);
}

// accessPageDiferent = (value) => window.location.href = '/#/checklist-answered/' + value + '?unconformities_only=false';


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/redirect/redirect.component.ts